type StateParams = {
  state: string;
  from?: string;
};

const SEPARATOR = ':';

const buildStateParamsString = function({ state, from }: StateParams): string {
  return [state, from].filter(s => typeof s === 'string').join(SEPARATOR);
};

const parseStateParams = function(value: string): StateParams {
  const [state, from] = value.split(SEPARATOR);

  return { state, from };
};

export { buildStateParamsString, parseStateParams };
